import { render } from "./workers.vue?vue&type=template&id=19fa391a&scoped=true"
import script from "./workers.vue?vue&type=script&lang=js"
export * from "./workers.vue?vue&type=script&lang=js"

import "./workers.vue?vue&type=style&index=0&id=19fa391a&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19fa391a"]])

export default __exports__